<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div v-if="isCoserRoute">
          <!-- 搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item prop="roleName">
                    <span slot="label"><a-tooltip>{{ $t('角色名') }}</a-tooltip></span>
                    <a-input v-model="coserQuery.roleName" :maxLength="32" :placeholder="$t('请输入角色名')" allow-clear @pressEnter="handleCoserQuery" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item prop="realName">
                    <span slot="label"><a-tooltip>{{ $t('真实姓名') }}</a-tooltip></span>
                    <a-input v-model="coserQuery.realName" :maxLength="32" :placeholder="$t('请输入真实姓名')" allow-clear @pressEnter="handleCoserQuery" />
                  </a-form-item>
                </a-col>
                <template v-if="coserAdvanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item prop="phone">
                      <span slot="label"><a-tooltip>{{ $t('联系方式') }}</a-tooltip></span>
                      <a-input v-model="coserQuery.phone" :maxLength="32" :placeholder="$t('请输入联系方式')" allow-clear @pressEnter="handleCoserQuery" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item prop="applyStatus">
                      <span slot="label"><a-tooltip>{{ $t('审核状态') }}</a-tooltip></span>
                      <a-select v-model="coserQuery.applyStatus" :placeholder="$t('选择状态')" allow-clear style="width: 100%">
                        <a-select-option :value="0">{{ $t('待审核') }}</a-select-option>
                        <a-select-option :value="1">{{ $t('已通过') }}</a-select-option>
                        <a-select-option :value="2">{{ $t('已拒绝') }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item :label="$t('提交开始时间')" prop="createBeginTime">
                      <a-date-picker style="width: 100%" v-model="coserQuery.createBeginTime"
                        :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                        valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item :label="$t('提交结束时间')" prop="createEndTime">
                      <a-date-picker style="width: 100%" v-model="coserQuery.createEndTime"
                        :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                        valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :md="!coserAdvanced && 6 || 24" :sm="24">
                  <span class="table-page-search-submitButtons" :style="coserAdvanced && { float: 'right', overflow: 'hidden' } || {}">
                    <a-button type="primary" @click="handleCoserQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                    <a-button style="margin-left: 8px" @click="resetCoserQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                    <a @click="coserAdvanced = !coserAdvanced" style="margin-left: 8px">
                      {{ coserAdvanced ? $t('收起') : $t('展开') }}
                      <a-icon :type="coserAdvanced ? 'up' : 'down'" />
                    </a>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- COSER自由行表格 -->
          <a-table :loading="coserLoading" :columns="coserColumns" :data-source="coserList" rowKey="id"
            :pagination="false" :scroll="{ x: 1200 }" :bordered="tableBordered" size="middle"
            @change="(p, f, s) => handleSortChange(s, 'coser')">
            <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
            <span slot="applyStatus" slot-scope="text, record">
              <a-tag v-if="record.applyStatus == 0" color="orange">{{ $t('待审核') }}</a-tag>
              <a-tag v-else-if="record.applyStatus == 1" color="green">{{ $t('已通过') }}</a-tag>
              <a-tag v-else-if="record.applyStatus == 2" color="red">{{ $t('已拒绝') }}</a-tag>
              <span v-else>{{ record.applyStatus }}</span>
            </span>
            <span slot="operation" slot-scope="text, record">
              <template v-if="record.applyStatus == 0">
                <a @click="handleAudit(record)" v-hasPermi="['community:communitygroupactivitycoserapply:edit']">
                  <a-icon type="check-circle" />{{ $t('审核') }}
                </a>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
          <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper
            :pageSizeOptions="pageSizeOptions" :current="coserQuery.pageNum" :total="coserTotal"
            :page-size="coserQuery.pageSize"
            :showTotal="total => $t('共') + total + $t('条')"
            @showSizeChange="(c, ps) => { coserQuery.pageSize = ps; getCoserList() }"
            @change="(p) => { coserQuery.pageNum = p; getCoserList() }" />
      </div>

      <div v-else>
          <!-- 搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="6" :sm="24">
                  <a-form-item prop="roleName">
                    <span slot="label"><a-tooltip>{{ $t('角色名') }}</a-tooltip></span>
                    <a-input v-model="photoQuery.roleName" :maxLength="32" :placeholder="$t('请输入角色名')" allow-clear @pressEnter="handlePhotoQuery" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item prop="realName">
                    <span slot="label"><a-tooltip>{{ $t('真实姓名') }}</a-tooltip></span>
                    <a-input v-model="photoQuery.realName" :maxLength="32" :placeholder="$t('请输入真实姓名')" allow-clear @pressEnter="handlePhotoQuery" />
                  </a-form-item>
                </a-col>
                <template v-if="photoAdvanced">
                  <a-col :md="6" :sm="24">
                    <a-form-item prop="phone">
                      <span slot="label"><a-tooltip>{{ $t('联系方式') }}</a-tooltip></span>
                      <a-input v-model="photoQuery.phone" :maxLength="32" :placeholder="$t('请输入联系方式')" allow-clear @pressEnter="handlePhotoQuery" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item prop="applyStatus">
                      <span slot="label"><a-tooltip>{{ $t('审核状态') }}</a-tooltip></span>
                      <a-select v-model="photoQuery.applyStatus" :placeholder="$t('选择状态')" allow-clear style="width: 100%">
                        <a-select-option :value="0">{{ $t('待审核') }}</a-select-option>
                        <a-select-option :value="1">{{ $t('已通过') }}</a-select-option>
                        <a-select-option :value="2">{{ $t('已拒绝') }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item :label="$t('提交开始时间')" prop="createBeginTime">
                      <a-date-picker style="width: 100%" v-model="photoQuery.createBeginTime"
                        :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                        valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item :label="$t('提交结束时间')" prop="createEndTime">
                      <a-date-picker style="width: 100%" v-model="photoQuery.createEndTime"
                        :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                        valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :md="!photoAdvanced && 6 || 24" :sm="24">
                  <span class="table-page-search-submitButtons" :style="photoAdvanced && { float: 'right', overflow: 'hidden' } || {}">
                    <a-button type="primary" @click="handlePhotoQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                    <a-button style="margin-left: 8px" @click="resetPhotoQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                    <a @click="photoAdvanced = !photoAdvanced" style="margin-left: 8px">
                      {{ photoAdvanced ? $t('收起') : $t('展开') }}
                      <a-icon :type="photoAdvanced ? 'up' : 'down'" />
                    </a>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 摄影师自由行表格 -->
          <a-table :loading="photoLoading" :columns="photoColumns" :data-source="photoList" rowKey="id"
            :pagination="false" :scroll="{ x: 1200 }" :bordered="tableBordered" size="middle"
            @change="(p, f, s) => handleSortChange(s, 'photo')">
            <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
            <span slot="applyStatus" slot-scope="text, record">
              <a-tag v-if="record.applyStatus == 0" color="orange">{{ $t('待审核') }}</a-tag>
              <a-tag v-else-if="record.applyStatus == 1" color="green">{{ $t('已通过') }}</a-tag>
              <a-tag v-else-if="record.applyStatus == 2" color="red">{{ $t('已拒绝') }}</a-tag>
              <span v-else>{{ record.applyStatus }}</span>
            </span>
            <span slot="operation" slot-scope="text, record">
              <template v-if="record.applyStatus == 0">
                <a @click="handleAudit(record)" v-hasPermi="['community:communitygroupactivitycoserapply:edit']">
                  <a-icon type="check-circle" />{{ $t('审核') }}
                </a>
              </template>
              <span v-else>-</span>
            </span>
          </a-table>
          <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper
            :pageSizeOptions="pageSizeOptions" :current="photoQuery.pageNum" :total="photoTotal"
            :page-size="photoQuery.pageSize"
            :showTotal="total => $t('共') + total + $t('条')"
            @showSizeChange="(c, ps) => { photoQuery.pageSize = ps; getPhotoList() }"
            @change="(p) => { photoQuery.pageNum = p; getPhotoList() }" />
      </div>

      <!-- 审核确认弹框 (共用) -->
      <a-modal :visible="auditModalVisible" :title="$t('审核申请')" @cancel="auditModalVisible = false" :footer="null">
        <p>{{ $t('确认审核通过？') }}</p>
        <div style="margin-top: 24px; border-top: 1px solid #f0f0f0; padding-top: 16px; text-align: right">
          <a-button type="primary" @click="handleAuditApprove">{{ $t('通过') }}</a-button>
          <a-button style="margin-right: 8px" @click="handleAuditReject">{{ $t('拒绝') }}</a-button>
          <a-button style="margin-right: 8px" @click="auditModalVisible = false">{{ $t('取消') }}</a-button>
        </div>
      </a-modal>

      <!-- 拒绝原因弹框 -->
      <a-modal :visible="rejectModalVisible" :title="$t('拒绝审核')" @cancel="rejectModalVisible = false" :footer="null">
        <p>{{ $t('请输入拒绝原因：') }}</p>
        <a-textarea v-model="rejectReason" :rows="4" :placeholder="$t('请输入拒绝原因')" style="margin-top: 8px" />
        <div style="margin-top: 24px; border-top: 1px solid #f0f0f0; padding-top: 16px; text-align: right">
          <a-button style="margin-right: 8px" @click="rejectModalVisible = false">{{ $t('取消') }}</a-button>
          <a-button type="primary" @click="handleRejectConfirm">{{ $t('确定拒绝') }}</a-button>
        </div>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { pageCommunityGroupActivityCoserApply } from '@/api/community/communityGroup/communityGroupActivityCoserApply'
import { auditActivityApply } from '@/api/community/communityGroup/communityGroupActivityCoserApply'

export default {
  name: 'CommunityGroupFreeTravelApply',
  data () {
    return {
      // COSER 相关
      coserLoading: false,
      coserList: [],
      coserTotal: 0,
      coserAdvanced: false,
      coserQuery: {
        pageNum: 1,
        pageSize: 10,
        applySource: 2,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        applyStatus: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      },
      coserSortField: '',
      coserSortOrder: '',
      // 摄影师相关
      photoLoading: false,
      photoList: [],
      photoTotal: 0,
      photoAdvanced: false,
      photoQuery: {
        pageNum: 1,
        pageSize: 10,
        applySource: 2,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        applyStatus: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      },
      photoSortField: '',
      photoSortOrder: '',
      // 通用
      tableBordered: true,
      pageSizeOptions: ['10', '20', '50', '100'],
      auditModalVisible: false,
      rejectModalVisible: false,
      auditRow: null,
      rejectReason: '',
      coserColumns: [
        { title: this.$t('编号'), dataIndex: 'id', width: 80, align: 'center' },
        { title: this.$t('活动ID'), dataIndex: 'activityId', width: 80, align: 'center' },
        { title: this.$t('角色名'), dataIndex: 'roleName', width: 130, align: 'center' },
        { title: this.$t('真实姓名'), dataIndex: 'realName', width: 130, align: 'center' },
        { title: this.$t('联系方式'), dataIndex: 'phone', width: 130, align: 'center' },
        { title: this.$t('审核状态'), dataIndex: 'applyStatus', width: 100, scopedSlots: { customRender: 'applyStatus' }, align: 'center' },
        { title: this.$t('审核原因'), dataIndex: 'auditReason', width: 200, align: 'center' },
        { title: this.$t('提交时间'), dataIndex: 'createTime', width: 160, scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: this.$t('操作'), dataIndex: 'operation', width: 100, scopedSlots: { customRender: 'operation' }, fixed: 'right', align: 'center' }
      ],
      photoColumns: [
        { title: this.$t('编号'), dataIndex: 'id', width: 80, align: 'center' },
        { title: this.$t('活动ID'), dataIndex: 'activityId', width: 80, align: 'center' },
        { title: this.$t('角色名'), dataIndex: 'roleName', width: 130, align: 'center' },
        { title: this.$t('真实姓名'), dataIndex: 'realName', width: 130, align: 'center' },
        { title: this.$t('联系方式'), dataIndex: 'phone', width: 130, align: 'center' },
        { title: this.$t('审核状态'), dataIndex: 'applyStatus', width: 100, scopedSlots: { customRender: 'applyStatus' }, align: 'center' },
        { title: this.$t('审核原因'), dataIndex: 'auditReason', width: 200, align: 'center' },
        { title: this.$t('提交时间'), dataIndex: 'createTime', width: 160, scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: this.$t('操作'), dataIndex: 'operation', width: 100, scopedSlots: { customRender: 'operation' }, fixed: 'right', align: 'center' }
      ]
    }
  },
  computed: {
    isCoserRoute () {
      return this.$route.path.includes('coser')
    }
  },
  created () {
    if (this.isCoserRoute) {
      this.getCoserList()
    } else {
      this.getPhotoList()
    }
  },
  methods: {
    moment,
    // COSER 查询
    getCoserList () {
      this.coserLoading = true
      const params = { ...this.coserQuery }
      if (this.coserSortField) {
        params.sortField = this.coserSortField
        params.sortOrder = this.coserSortOrder
      }
      pageCommunityGroupActivityCoserApply(params).then(res => {
        this.coserList = res.data.records
        this.coserTotal = res.data.total
        this.coserLoading = false
      }).catch(() => { this.coserLoading = false })
    },
    handleCoserQuery () {
      this.coserQuery.pageNum = 1
      this.getCoserList()
    },
    resetCoserQuery () {
      this.coserQuery = {
        pageNum: 1,
        pageSize: 10,
        applySource: 2,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        applyStatus: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      }
      this.coserSortField = ''
      this.coserSortOrder = ''
      this.getCoserList()
    },
    // 摄影师查询（共用一张表，通过 applyType=20 区分）
    getPhotoList () {
      this.photoLoading = true
      const params = { ...this.photoQuery, applyType: 20 }
      if (this.photoSortField) {
        params.sortField = this.photoSortField
        params.sortOrder = this.photoSortOrder
      }
      pageCommunityGroupActivityCoserApply(params).then(res => {
        this.photoList = res.data.records
        this.photoTotal = res.data.total
        this.photoLoading = false
      }).catch(() => { this.photoLoading = false })
    },
    handlePhotoQuery () {
      this.photoQuery.pageNum = 1
      this.getPhotoList()
    },
    resetPhotoQuery () {
      this.photoQuery = {
        pageNum: 1,
        pageSize: 10,
        applySource: 2,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        applyStatus: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      }
      this.photoSortField = ''
      this.photoSortOrder = ''
      this.getPhotoList()
    },
    // 排序
    handleSortChange (sorter, type) {
      if (sorter.order) {
        const field = sorter.columnKey === 'createTime' ? 'id' : sorter.columnKey
        if (type === 'coser') {
          this.coserSortField = field
          this.coserSortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
          this.getCoserList()
        } else {
          this.photoSortField = field
          this.photoSortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
          this.getPhotoList()
        }
      }
    },
    // 审核
    handleAudit (row) {
      this.auditRow = row
      this.auditModalVisible = true
    },
    handleAuditApprove () {
      const row = this.auditRow
      const applyType = this.isCoserRoute ? 10 : 20
      auditActivityApply({ id: row.id, auditStatus: 1, applyType: applyType })
        .then(() => {
          this.auditModalVisible = false
          this.auditRow = null
          this.refreshCurrentTab()
          this.$message.success(this.$t('审核通过'), 3)
        })
    },
    handleAuditReject () {
      this.rejectReason = ''
      this.rejectModalVisible = true
    },
    handleRejectConfirm () {
      const reason = this.rejectReason
      if (!reason) {
        this.$message.error(this.$t('拒绝原因不能为空'))
        return
      }
      const row = this.auditRow
      const applyType = this.isCoserRoute ? 10 : 20
      auditActivityApply({ id: row.id, auditStatus: 2, auditReason: reason, applyType: applyType })
        .then(() => {
          this.rejectModalVisible = false
          this.auditModalVisible = false
          this.auditRow = null
          this.refreshCurrentTab()
          this.$message.success(this.$t('已拒绝'), 3)
        })
    },
    refreshCurrentTab () {
      if (this.isCoserRoute) {
        this.getCoserList()
      } else {
        this.getPhotoList()
      }
    }
  }
}
</script>
